/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconArrowRight from '@telus-uds/palette-allium/build/rn/icons/ArrowRight'
import PaletteIconStatusWarning from '@telus-uds/palette-allium/build/rn/icons/StatusWarning'
import PaletteIconStatusError from '@telus-uds/palette-allium/build/rn/icons/StatusError'
const theme = {
  appearances: {
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    validation: {
      description: 'Validation states for form inputs',
      type: 'state',
      values: [ 'error', 'success', 'warning', 'feature' ]
    }
  },
  rules: [
    { if: { hover: true }, tokens: { actionIconTranslate: 4 } },
    {
      if: { validation: 'warning' },
      tokens: {
        actionIconMarginLeft: 8,
        backgroundColor: '#fff9ee',
        borderColor: '#c77539',
        statusIcon: PaletteIconStatusWarning,
        statusIconColor: '#c77539'
      }
    },
    {
      if: { validation: 'error' },
      tokens: {
        actionIconMarginLeft: 8,
        backgroundColor: '#fff6f8',
        borderColor: '#e12339',
        statusIcon: PaletteIconStatusError,
        statusIconColor: '#e12339'
      }
    }
  ],
  tokens: {
    actionIcon: PaletteIconArrowRight,
    actionIconColor: '#414547',
    actionIconMarginBottom: 8,
    actionIconMarginLeft: 0,
    actionIconMarginRight: 0,
    actionIconMarginTop: 8,
    actionIconTranslate: 4,
    backgroundColor: null,
    borderColor: null,
    borderRadius: null,
    borderWidth: null,
    contentFontColor: '#414547',
    contentFontName: 'HNforTELUSSA',
    contentFontSize: 16,
    contentFontWeight: '400',
    contentLineHeight: 1.25,
    contentMarginBottom: 8,
    contentMarginLeft: 0,
    contentMarginRight: 0,
    contentMarginTop: 0,
    iconBackgroundColor: 'rgba(0, 0, 0, 0.05)',
    iconColor: '#414547',
    iconMarginBottom: 0,
    iconMarginLeft: 0,
    iconMarginRight: 8,
    iconMarginTop: 0,
    paddingBottom: 16,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 16,
    statusIcon: null,
    statusIconColor: null,
    titleFontColor: '#414547',
    titleFontName: 'HNforTELUSSA',
    titleFontSize: 16,
    titleFontWeight: '700',
    titleLineHeight: 1.5,
    titleMarginBottom: 8,
    titleMarginLeft: 0,
    titleMarginRight: 8,
    titleMarginTop: 8
  }
}
export default theme
